// extracted by mini-css-extract-plugin
export var scrollArea = "_p6-0";